import { colors } from "@/styles/colors"

import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	tooltipInfoIcon: {
		backgroundColor: colors.gray[0],
		borderRadius: "100%",
		width: 16,
		height: 16,
		padding: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	infoIconGlyph: {
		fontSize: 11,
		fontWeight: 600,
		lineHeight: 1,
		color: colors.purple[500]
	},
	dismissableHintChip: {
		borderColor: colors.purple[200],
		color: colors.purple[600],
		backgroundColor: colors.purple[100],
		fontWeight: 600,
		"& .MuiChip-label": {
			display: "flex",
			alignItems: "center",
			gap: 4
		}
	},
	dismissableHintDeleteIcon: {
		color: colors.purple[500],
		"&:hover": {
			backgroundColor: colors.purple[100]
		}
	}
})

export default useStyles
